module.exports = __webpack_public_path__ + "img/content.cb8a9b37.png";